module.exports = __webpack_public_path__ + "static/media/pencil.a44b653b.svg";